import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NationalStockPage } from './national-stock.page';

const routes: Routes = [
  {
    path: '',
    component: NationalStockPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NationalStockPageRoutingModule {}
